module.exports = __webpack_public_path__ + "img/p1M.15995d82.png";